import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordField = ({ value, onChange, placeholder = "••••••••", testid, minLength, required, autoComplete }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        className="field h-9 w-full pr-9"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        minLength={minLength}
        required={required}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        tabIndex={-1}
        data-testid={testid ? `${testid}-toggle` : undefined}
        onClick={() => setShow((s) => !s)}
        title={show ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-[#22A34A] transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};
